
import React, { Component } from 'react';
import { Checkbox } from 'antd';

export class Department extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         value: null,
    //         status: false,
    //         statusP: true,
    //     }
    // }

    // handleChangeDepartment = async (v) => {
    //     if(!this.state.valueS){
    //         await this.setState({
    //             valueS: v,
    //             status: true,
    //             statusP: false,
    //         })
    //     } else {
    //         if(v === this.state.valueS){
    //             await this.setState({
    //                 valueS: null,
    //                 status: false,
    //                 statusP: false,
    //             })
    //         } else {
    //             await this.setState({
    //                 valueS: v,
    //                 status: true,
    //                 statusP: false,
    //             })
    //         }
    //     }
    //     const { onChange } = this.props;
    //     onChange(this.state.valueS);
    // }

    handleChangeDepartment = (value)  => {
        const { onChange } = this.props;
        onChange(value);
    }

    render() {
        const { editable, typeOption, value } = this.props;
        // const { status, valueS, statusP } = this.state;
        return (
            <div className="department">
                <Checkbox
                    disabled={!editable || typeOption === "edit"}
                    onChange={() => this.handleChangeDepartment(1)}
                    checked={value === 1}
                >
                    Admin điều hành
                </Checkbox>
                <Checkbox 
                    disabled={!editable || typeOption === "edit"}
                    onChange={() => this.handleChangeDepartment(2)}
                    checked={value === 2}
                >
                    Điều hành khối
                </Checkbox>
                <Checkbox 
                    disabled={!editable || typeOption === "edit"}
                    onChange={() => this.handleChangeDepartment(3)}
                    checked={value === 3}
                >
                    Kế toán
                </Checkbox>
                {/* <Checkbox 
                    disabled={!editable || typeOption === 'edit'}
                    onChange={() => this.handleChangeDepartment(1)}
                    checked={valueS === 1 && status || value === 1 && statusP}
                >
                    Admin điều hành
                </Checkbox>
                <Checkbox
                    disabled={!editable || typeOption === 'edit'}
                    onChange={() => this.handleChangeDepartment(2)}
                    checked={valueS === 2 && status || value === 2 && statusP}
                >
                    Điều hành khối
                </Checkbox>
                <Checkbox 
                    disabled={!editable || typeOption === 'edit'}
                    onChange={() => this.handleChangeDepartment(3)}
                    checked={valueS === 3 && status || value === 3 && statusP}
                >
                    Kế toán
                </Checkbox> */}
            </div>
        )
    }
}